import url from 'url';

export default {
    getURL(): string {
        if (
            window &&
            'location' in window &&
            'protocol' in window.location &&
            'pathname' in window.location &&
            'host' in window.location
        ) {
            return (
                window.location.protocol +
                '//' +
                window.location.host +
                window.location.pathname +
                window.location.search
            );
        }
        return '';
    },
    parseURL(path: string): any {
        if (path === '') return {};
        return url.parse(path);
    },
    getURLBase(): string {
        const url = this.parseURL(this.getURL() || '');
        return url.protocol + '//' + url.host;
    },
    getHeader(url: string) {
        return new Promise((resolve, reject) => {
            const req = new XMLHttpRequest();
            req.open('GET', url);
            req.onload = () => {
                const headers: { [key: string]: string } = {};
                req.getAllResponseHeaders()
                    .trim()
                    .split(/[\r\n]+/)
                    .map(value => value.split(/: /))
                    .forEach(keyValue => {
                        headers[keyValue[0].trim().toLowerCase()] = keyValue[1].trim();
                    });
                resolve(headers);
            };
            req.onerror = () => {
                reject({
                    status: req.status,
                    statusText: req.statusText
                });
            };
            req.send();
        });
    }
};
